import {
  Component,
  ViewChild,
  AfterViewInit,
  Input,
  forwardRef,
  Output,
  EventEmitter
} from '@angular/core';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { DropdownItem, DropdownGroup } from '@tripointe/tripointe-cms/types';

const DROPDOWN_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DropdownComponent),
  multi: true
};

@Component({
  selector: 'tp-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [DROPDOWN_VALUE_ACCESSOR]
})
export class DropdownComponent implements AfterViewInit, ControlValueAccessor {
  @Input() multiple: boolean;
  @Input() grouped = false;
  @Input() placeholder = '';
  @Input() emitOptionValue: boolean;
  @Input() options: DropdownItem[] | DropdownGroup[] = [];
  @Input() placeholderOpacity: boolean;
  @Input() tabIndex: number;
  @Input() isDisabled: boolean;
  @Output() valueChange = new EventEmitter();
  @ViewChild(MatSelect, { static: true }) selectRef: MatSelect;

  selectedOption: any = '';
  propagateChange = (_: any) => {};
  onTouched = () => {};
  onChange = (value: any) => {};

  ngAfterViewInit(): void {
    this.selectRef.overlayDir.offsetY = 10;
    this.selectRef.overlayDir.offsetX = 0;
    this.selectRef.overlayDir.minWidth = '300px';
    this.selectRef.overlayDir.positions = [
      {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top'
      }
    ];
  }

  writeValue(value: string | Array<any>): void {
    this.selectedOption = value;
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.selectRef.setDisabledState(isDisabled);
  }

  onSelectionChange(option: MatSelectChange): void {
    this.valueChange.emit(option.value);

    if (this.multiple && option.value.some(val => val === null)) {
      this.selectedOption = [null];
      this.propagateChange(this.selectedOption);
      this.selectRef.close();

      return;
    }

    this.selectedOption = option.value;
    this.propagateChange(this.selectedOption);
  }

  onOpenChanged(isOpen: boolean): void {
    if (!isOpen) {
      this.onTouched();
    } else {
      this.changePanelParams();
    }
  }

  private changePanelParams(): void {
    const bodyClientRect = document.body.getBoundingClientRect();
    const elemClientRect = this.selectRef.trigger.nativeElement.getBoundingClientRect();
    const difference = bodyClientRect.bottom - elemClientRect.bottom;

    if (difference < 280) {
      (document.querySelector('.mat-select-panel') as HTMLDivElement).style.maxHeight =
        difference - 10 + 'px';
    }
  }
}
